import React from 'react';
import { Icons, Text, styled } from '@/theme/index';

export const MobileSearch = styled('div')(({ theme }) => ({
  border: '1px solid #000000',
  borderRadius: '3px',
  fontStyle: 'italic',
  height: '35px',
  position: 'relative',
  marginTop: theme.spacing(1.5),
  padding: `${theme.spacing(1)} ${theme.spacing(0.75)}`,
  display: 'block',
  fontSize: '12px',
  width: '60%',

  [theme.breakpoints.down('md')]: {
    width: '45%',
  },

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },

  '&:hover': {
    cursor: 'pointer',
  },
}));

interface MobileSearchInputProps {
  toggleIsMounted: () => void;
  smartSearchIcon?: boolean;
  openSmartSearch?: () => void;
}

export function MobileSearchInput({
  toggleIsMounted,
  smartSearchIcon,
  openSmartSearch,
}: MobileSearchInputProps) {
  const handleSmartSearchClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (openSmartSearch) {
      openSmartSearch();
    }
  };

  return (
    <MobileSearch onClick={toggleIsMounted}>
      <Text fontSize="12px">
        <Icons.Search
          color="primary"
          sx={{ verticalAlign: 'bottom', fontSize: '1rem' }}
        />
        Start search
      </Text>
      {smartSearchIcon && (
        <Icons.AutoAwesome
          sx={{
            position: 'absolute',
            top: '1px',
            right: '1px',
          }}
          onClick={handleSmartSearchClick}
        />
      )}
    </MobileSearch>
  );
}
